import React from 'react';
import '../App.scss';
import {NavLink} from 'react-router-dom';

const Title = ()=>{
  return(
    <div class="row">
          <div class="col-8 col-md-6  mb-5">
            <h4 class="text-left font-weight-bold">INDIA COVID-19 NEWS</h4>
            <p class="text-left logo-subtext">Get covid-19 news from leading sources</p>
          </div>
        </div>
  )
}     
export default Title 
